import React, { useEffect } from "react";
import { Dialog, Slideover } from "src/base-components/Headless";
import Lucide from "src/base-components/Lucide";
import SlideoverModal from "src/components/SlideoverModal";
import QueryDetail from "src/pages/Queries/QueryDetail";

interface Props {
  openViewModal: boolean;
  handleClose: () => void;
  getqueryID?: string | null;
}

const ViewQueryModal: React.FC<Props> = ({
  openViewModal,
  getqueryID,
  handleClose,
}) => {
  useEffect(() => {
    if (openViewModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openViewModal]);
  return (
    <>
      {/* <Dialog
        open={openViewModal}
        onClose={() => {}}
        className="w-full"
        size="2xl"
      >
        <Dialog.Panel className="relative z-[10000] mt-10 p-5 bg-white rounded-lg mb-5">
          
          <button
            onClick={handleClose}
            className="absolute top-3 right-3  focus:outline-none hover:bg-white/100 bg-white/5 transition-all hover:rotate-180 flex items-center justify-center border rounded-full w-9 h-9"
          >
            <Lucide className="w-7 h-7 stroke-[1]" icon="X" />
          </button>
          <div className="mt-10">
            <QueryDetail queryId={getqueryID} />
          </div>
        </Dialog.Panel>
      </Dialog> */}
      <Dialog
        open={openViewModal}
        onClose={() => {}}
        className="w-full"
        staticBackdrop={true}
        size="2xl"
      >
        <Dialog.Panel className="relative z-[10000] mt-10 p-5 bg-white rounded-lg mb-5">
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 focus:outline-none hover:bg-white/100 bg-white/5 transition-all hover:rotate-180 flex items-center justify-center border rounded-full w-9 h-9"
          >
            <Lucide className="w-7 h-7 stroke-[1]" icon="X" />
          </button>
          <div className="mt-10">
            <QueryDetail queryId={getqueryID} />
          </div>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

export default ViewQueryModal;
